"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styles_1 = require("./styles");

var Checkbox_1 = require("../../forms/Checkbox");

function FullTableRowCheckbox(props) {
  var selected = props.selected,
      index = props.index,
      selectRow = props.selectRow;
  return React.createElement("div", __assign({
    tabIndex: 0,
    role: "cell",
    className: "selectRowCell"
  }, styles_1.selectRowCellStyle), React.createElement(Checkbox_1.Checkbox, {
    selected: selected,
    onChange: function onChange() {
      return selectRow(index);
    }
  }));
}

exports.FullTableRowCheckbox = FullTableRowCheckbox;